import React from 'react'
import PropTypes from 'prop-types'
import RichText from '../RichText'

const DisclaimerPageLayout = ({ title, subtitle, content }) => (
  <div className="mx-auto max-w-1400">
    <div
      className="bg-gray-160 px-6 py-10 text-center md:px-0"
      data-testid="header"
    >
      <h1 className="mb-5 text-4xl text-blue-700" data-testid="title">
        {title}
      </h1>
      <p
        className="mx-auto mb-5 text-lg text-gray-400 md:mb-6 md:w-140"
        data-testid="subtitle"
      >
        {subtitle}
      </p>
    </div>
    <RichText
      contentData={content}
      className="px-8 pb-6  pt-8 text-sm text-gray-400 md:px-8 lg:px-16 lg:py-10"
    />
  </div>
)

DisclaimerPageLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
}
export default DisclaimerPageLayout
